import axios from 'axios'

const apiUrl = 'https://sitebypro-server.ru/druzbamebel'

export default {
  state: {
    items: [],
    loading: false
  },
  getters: {
    newsItems(state) { return state.items },
    newsLoading(state) { return state.loading }
  },
  mutations: {
    SET_NEWS(state, data) { state.items = Array.isArray(data) ? data : [] },
    SET_NEWS_LOADING(state, value) { state.loading = Boolean(value) }
  },
  actions: {
    async GET_NEWS({ commit, getters }, force = false) {
      if (!force && getters.newsItems.length) return getters.newsItems
      commit('SET_NEWS_LOADING', true)
      try {
        const response = await axios.get(`${apiUrl}/equipment/get-news`)
        const data = Array.isArray(response?.data?.data) ? response.data.data : []
        commit('SET_NEWS', data)
        return data
      } catch (error) {
        console.warn('Не удалось загрузить статьи', error)
        commit('SET_NEWS', [])
        return []
      } finally {
        commit('SET_NEWS_LOADING', false)
      }
    },
    async GET_NEWS_BY_SLUG(context, slug) {
      try {
        const response = await axios.post(`${apiUrl}/equipment/get-news-by-slug`, { slug })
        return response?.data?.data || null
      } catch (error) {
        console.warn('Не удалось загрузить статью', error)
        return null
      }
    }
  }
}
